import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { first } from 'rxjs/operators';

export interface ToastOptions {
    vertical?: 'top' | 'bottom';
    horizontal?: 'left' | 'center' | 'right';
    duration?: number;
    type: 'success' | 'warning' | 'generic';
}

@Injectable({
    providedIn: 'root',
})
export class ToasterService {
    constructor() {}

    private _eject = new Subject<{ message: string; title?: string; options?: ToastOptions }>();
    get eject$(): Observable<{ message: string; title?: string; options?: ToastOptions }> {
        return this._eject;
    }
    private _close = new Subject<void>();
    get close$(): Observable<void> {
        return this._close;
    }

    eject(message: string, title?: string, options?: ToastOptions): Observable<void> {
        this._eject.next({ message, title, options });
        return this._close.pipe(first());
    }

    close() {
        this._close.next();
    }
}
